export const STATES = {
  READY: 'READY',
  LOADING: 'LOADING'
}

export const EVENTS = {
  CHANGE_CARD_LOADING_STATE: 'CHANGE_CARD_LOADING_STATE'
} as const
